var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page__title"
  }, [_vm._v(" " + _vm._s(_vm.getModuleConfig("redeem_failed_page.form_title")) + " ")]), _c('div', {
    staticClass: "page__desc",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_failed_page.form_desc'))
    }
  }), _c('div', [_vm.showLoading ? _c('Loading', {
    attrs: {
      "loading-message": "載入中..."
    }
  }) : !_vm.showLoading ? _c('div', [_c('div', {
    staticClass: "coupon"
  }, [_vm.qrcode1 ? _c('div', {
    staticClass: "coupon--barcode s-mb-4"
  }, [_vm.showBarcodeError1 ? _c('p', {
    staticClass: "s-text-danger"
  }, [_vm._v(" barcode 產生錯誤，請聯絡相關人員 ")]) : _c('img', {
    attrs: {
      "id": _vm.barcodeImgIdOne,
      "src": require("@/pages/Dashboard/Coupon/barcode.png")
    }
  })]) : _vm._e(), _vm.qrcode2 ? _c('div', {
    staticClass: "coupon--barcode s-mb-4"
  }, [_vm.showBarcodeError2 ? _c('p', {
    staticClass: "s-text-danger"
  }, [_vm._v(" barcode 產生錯誤，請聯絡相關人員 ")]) : _c('img', {
    attrs: {
      "id": _vm.barcodeImgIdTwo,
      "src": require("@/pages/Dashboard/Coupon/barcode.png")
    }
  })]) : _vm._e(), _c('div', {
    staticClass: "p-4 shadow-lg rounded redeem--content",
    domProps: {
      "innerHTML": _vm._s(_vm.getModuleConfig('redeem_failed_page.content'))
    }
  }), _c('div', [_vm._v(" " + _vm._s(_vm.messages) + " ")])])]) : _vm._e()], 1), _vm.getModuleConfig('redeem_failed_page.button_text') || _vm.getModuleConfig('redeem_failed_page.cancel_button_text') ? _c('div', {
    staticClass: "p-3 fixed-bottom bg-white footer"
  }, [_c('MemberButton', {
    attrs: {
      "button-text": _vm.getModuleConfig('redeem_failed_page.button_text'),
      "button-url": _vm.getModuleConfig('redeem_failed_page.button_url'),
      "type": _vm.getModuleConfig('redeem_failed_page.button_action')
    }
  })], 1) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }